import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PerfiladoComponent } from './perfilado/perfilado.component';
import { PropiedadesPerfilComponent } from './perfilado/propiedades-perfil/propiedades-perfil.component';

const routes: Routes = [
  { 
    path: '**', 
    redirectTo: 'perfilado-empleados', 
    pathMatch: 'full' 
  },
  {
    path: 'perfilado-empleados/:idUsuario/:idCliente',
    component: PerfiladoComponent,
    pathMatch: 'full' 
  },
  {
    path: 'propiedades-perfil',
    component: PropiedadesPerfilComponent,
  }, 
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
